import { render, staticRenderFns } from "./moreHonor.vue?vue&type=template&id=f79544fa&scoped=true"
import script from "./moreHonor.vue?vue&type=script&lang=js"
export * from "./moreHonor.vue?vue&type=script&lang=js"
import style0 from "./moreHonor.vue?vue&type=style&index=0&id=f79544fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79544fa",
  null
  
)

export default component.exports